import axios from 'axios';
import ss from './Session';
import * as amplitude from '@amplitude/analytics-browser';
import { sendTwitterConversion } from '../SendTwitterConversation';

const randomString = (length) =>
  new Array(length).fill(0)
    .map((x) => String.fromCharCode(65 + Math.floor(Math.random() * 2) * 32 + Math.floor(Math.random() * 26)))
    .join("");

// eslint-disable-next-line no-template-curly-in-string
const package_version = ((window?.package_version || "NA") === '${package_version}')?"DEV":(window?.package_version || "NA");

export async function logBehavior (what, detail) {

    if (!detail){
        detail = {}
    }

    if (!detail.page){
        detail.page = window.location.pathname;
    }

    if (!sessionStorage.getItem('sessionid')){
        let currentTime = (new Date()).getTime()/1000;
        let sessionid = localStorage.getItem('sessionid');
        let sessionNumber = 1;
        try {
            sessionNumber = Number(localStorage.getItem('session:number') || "1") || 1;
            if (localStorage.getItem('session:number') && localStorage.getItem('session:number').replace(/1/g,'').length === 0){
                sessionNumber = localStorage.getItem('session:number').length;
            }
        }catch(e){
            console.error('invalid sessionNumber', e);
        }
        if (!sessionid){
            sessionid = randomString(16);
            localStorage.setItem('sessionid', sessionid);
            localStorage.setItem('session:firstStartedAt', currentTime);

            await sendBehavior("sessionStart", {});
        }else {
            sessionNumber += 1;
            await sendBehavior("revisit", {
                interval: currentTime - Number(localStorage.getItem('session:lastStartedAt') || '0'),
                intervalFromStart: currentTime - Number(localStorage.getItem('session:firstStartedAt') || '0'),
                sessionNumber
            });
        }
        localStorage.setItem('session:lastStartedAt', currentTime);
        localStorage.setItem('session:number', sessionNumber);
        sessionStorage.setItem('sessionid', sessionid);
    }

    return await sendBehavior(what, detail);
}

async function sendBehavior (what, detail) {
    let sessionid = localStorage.getItem('sessionid');
    if (!detail.page){
        if (window.canonicalPath){
            detail.page = window.canonicalPath;
        }else{
            detail.page = window.location.pathname;
        }
    }
    
    if (['127.0.0.1', 'localhost:3000', 'mydomain.com:3000', 'localhost:3001', 'mydomain.com:3001', 'd26pjf3a18hvh4.cloudfront.net', 'dev.webtoon.today', 'challenge-dev.webtoon.today'].indexOf(window.location.host) >= 0){
        detail.debug = true;
    }
    
    let userid = ss.getCurrentSession().userid;
    let email  = ss.getCurrentSession().email || "";
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/behavior', {logs:[ {what, userid, sessionid, detail, package_version} ]}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        await sendTwitterConversion(what, userid, email);
        await amplitude.logEvent(what, {userid, sessionid, detail}).promise();

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

export async function logBulkBehavior (arr) {
    
    
    let userid = ss.getCurrentSession().userid;
    let sessionid = localStorage.getItem('sessionid');

    let logs = arr.map(row => ({
        sessionid,
        userid,
        what: row.what,
        package_version,
        detail: {
            page: window.canonicalPath || window.location.pathname,
            ...(row.detail),
            ...((['127.0.0.1', 'localhost:3000', 'mydomain.com:3000', 'localhost:3001', 'mydomain.com:3001', 'd26pjf3a18hvh4.cloudfront.net', 'dev.webtoon.today', 'challenge-dev.webtoon.today'].indexOf(window.location.host) >= 0)
                ?{debug: true}:{})
        },
    }))
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/behavior', {logs}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

/**
 * 
 * @param {{
 *   transaction_id: string,
 *   value: number,
 *   tax?: number,
 *   coupon?: string,
 *   currency: "KRW",
 *   items: {
 *     item_id: string,
 *     item_name: string,
 *     quantity: number
 *   }[]
 * }} detail 
 */
export async function logPurchase (detail) {
    try{
        if ('gtag' in window){
            window.gtag('event', 'purchase', detail);
        }
    }catch(e){
    }
}